import axios from "axios";
import { eHierarchyLevel } from "../enums";
import { IAxiosReturn } from "../interface";
import { processAxiosError } from "../processAxiosError";

export type HierarchyTagCheckReturn = IAxiosReturn<{ isNew: boolean; isValid: boolean }>;

/**
 * Check whether a hierarchy tag is valid and new for a level.
 *
 * @param backEndUrl - Base backend URL
 * @param hierarchy - Object containing the tag and hierarchy level to check.
 * @param hierarchy.hierarchyTag - The hierarchy tag string to validate (e.g., "D123").
 * @param hierarchy.level - The hierarchy level enum value used to scope the check.
 * @param controller - Optional `AbortController` to cancel the request.
 * @returns Object indicating whether the tag is valid and whether it is new.
 */
export const checkHierarchyTag = async (
  backEndUrl: string,
  hierarchy: { hierarchyTag: string; level: eHierarchyLevel },
  controller?: AbortController,
): Promise<HierarchyTagCheckReturn> => {
  try {
    const url = new URL(`${backEndUrl}Hierarchy/CheckTag`);
    url.searchParams.append("hierarchyTag", hierarchy.hierarchyTag);
    url.searchParams.append("level", hierarchy.level);
    const response: { data: { isNew: boolean; isValid: boolean } } = await axios.get(
      url.href,
      controller !== undefined ? { signal: controller.signal } : undefined,
    );
    return { success: true, data: response.data };
  } catch (error: unknown) {
    return processAxiosError("CheckHierarchyTag request failed", error);
  }
};
